import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const bookCollectionDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "book-collection",
        action: "start",
        section: "card",
        type: "",
        value: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default bookCollectionDataPush;
